import * as React from 'react';

import { useArgs } from '@storybook/preview-api';
import { Meta } from '@storybook/react';

import { SmallButton } from '~shared/components/buttons';

import { PauseActivityPaywall } from './PauseActivityPaywall';

export default {
  title: 'Teacher/Activity/Paywall Dialog',
  component: PauseActivityPaywall,
  parameters: { actions: { argTypesRegex: '^on.*' } },
} as Meta;

export const PauseActivityPaywallModal = () => {
  const [{ open }, updateArgs] = useArgs();
  return (
    <>
      <SmallButton onClick={() => updateArgs({ open: !open })}>
        Open dialog
      </SmallButton>
      <PauseActivityPaywall
        onClose={() => updateArgs({ open: false })}
        open={open}
      />
    </>
  );
};
